import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { UpgradeModule } from '@angular/upgrade/static';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NgrxFormsModule } from 'ngrx-forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SafePipeModule } from 'safe-pipe';
import { ConnectionProfilesComponent } from './connection-profiles.component';
import { ConnectionProfilesEffects } from './state/connection-profiles.effects';
import { ConnectionProfilesReducer, STORE_FEATURE_KEY_CONNECTION_PROFILES } from './state/connection-profiles.reducer';
import { AdminSatelliteService } from '../services/admin/admin-satellite.service';
import { ConnectionProfilesSelectors } from './state/connection-profiles.selectors';

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        UpgradeModule,
        FormsModule,
        NgrxFormsModule,
        ReactiveFormsModule,
        TooltipModule,
        SafePipeModule,
        EffectsModule.forFeature([ConnectionProfilesEffects]),
        StoreModule.forFeature(STORE_FEATURE_KEY_CONNECTION_PROFILES, ConnectionProfilesReducer)
    ]
    ,
    declarations: [
       ConnectionProfilesComponent
    ],
    providers: [
        AdminSatelliteService,
        ConnectionProfilesSelectors
    ],
    exports: [
    ]
})
export class ConnectionProfilesModule {
}
